module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"menu":"Menu: {0}","service":"Service: {0}","product":"Product: {0}","default":"Default","searching":"searching..."},"es":{"menu":"Menú: {0}","service":"Servicio: {0}","product":"Producto: {0}","default":"Por defecto","searching":"buscando..."}}')
  delete Component.options._Ctor
}
